import arrayToString from '../arrayToString';
var stringifyValues = function stringifyValues(value, options) {
  if (options === void 0) {
    options = {};
  }
  var _options = options,
    _options$separator = _options.separator,
    separator = _options$separator === void 0 ? ',' : _options$separator,
    _options$ignoreNull = _options.ignoreNull,
    ignoreNull = _options$ignoreNull === void 0 ? true : _options$ignoreNull;
  if (Array.isArray(value) || typeof value === 'string') {
    return arrayToString(value, separator);
  }
  if (typeof value === 'number' || typeof value === 'boolean') {
    // parens are needed for numbers to call toString, or else JS thinks it's a decimal and expects more numbers
    // but parens get stripped out in the build process
    return value + '';
  }
  if (value === null || value === undefined) {
    return ignoreNull ? value : '';
  }
  return typeof value.toString === 'function' ? value.toString() : '';
};
export default stringifyValues;